const PRICE_CATEGORY_LABELS: Record<string, string> = {
  adults: 'Erwachsene:r',
  children: 'Kind',
  couple: 'Paar',
  family: 'Familie',
  group: 'Gruppe',
  juveniles: 'Jugendliche:r',
  persons: 'Person',
  reduced: 'Ermäßigt',
  seniors: 'Senior:in',
  ticket: 'Ticket',
  toddlers: 'Kleinkind',
}

export function getExperiencePriceCategoryLabel(category: string) {
  // The backend can also return free-text labels in this field.
  return PRICE_CATEGORY_LABELS[category] ?? category
}
